import { render, staticRenderFns } from "./IP_BasicSummary.vue?vue&type=template&id=068a1e50&scoped=true&"
import script from "./IP_BasicSummary.vue?vue&type=script&lang=js&"
export * from "./IP_BasicSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068a1e50",
  null
  
)

export default component.exports